import { Vector3, Quaternion } from "@babylonjs/core/Maths/math.vector";
import { PointerEventTypes } from "@babylonjs/core/Events/pointerEvents";
import { Observable } from "@babylonjs/core/Misc/observable";

export default class PointerRotateBehavior {

    constructor() {
        this.enabled = true;
        this.detachCameraControls = true;

        this.onRotateObservable = new Observable();
        this.onRotateStartObservable = new Observable();
        this.onRotateEndObservable = new Observable();
    }


    validateDrag(targetPosition) { return true; };

    get name() {
        return "PointerRotate";
    }


    init() {
        this.dragging = false;
        this.attachedNode = null;
        this.currentDraggingPointerID = -1;
    }

    attach(target) {
        this.scene = target.getScene();
        this.attachedNode = target;


        var pickPredicate = (m) => {
            return this.attachedNode == m || m.isDescendantOf(this.attachedNode);
        };


        this._pointerObserver = this.scene.onPointerObservable.add((pointerInfo, eventState) => {
            if (!this.enabled) {
                return;
            }

            if (pointerInfo.type == PointerEventTypes.POINTERDOWN) {

                if (!this.dragging && pointerInfo.pickInfo && pointerInfo.pickInfo.hit && pointerInfo.pickInfo.pickedMesh && pointerInfo.pickInfo.pickedPoint && pointerInfo.pickInfo.ray && pickPredicate(pointerInfo.pickInfo.pickedMesh)) {
                    this._startDrag(pointerInfo.event.pointerId, pointerInfo.pickInfo.ray, pointerInfo.pickInfo.pickedPoint);
                }
            } else if (pointerInfo.type == PointerEventTypes.POINTERUP) {
                if (this.currentDraggingPointerID == pointerInfo.event.pointerId) {
                    this.releaseDrag();
                }
            } else if (pointerInfo.type == PointerEventTypes.POINTERMOVE) {
                var pointerId = pointerInfo.event.pointerId;

                if (this.dragging && this.currentDraggingPointerID == pointerId) {
                    let angleDelta = (this.prevPointerY - this.scene.pointerY) / 100;
                    this.attachedNode.rotate(new Vector3(1, 0, 0), angleDelta);
                    this.onRotateObservable.notifyObservers();
                    this.prevPointerY = this.scene.pointerY;
                }
            }
        });

    }

    setRotation(x, w) {
        this.attachedNode.rotationQuaternion = new Quaternion(x, 0, 0, w);
        this.onRotateObservable.notifyObservers();
    }

    releaseDrag() {
        this.dragging = false;
        this.onRotateEndObservable.notifyObservers();

        // Reattach camera controls
        if (this.detachCameraControls && this._attachedElement && this.scene.activeCamera && !this.scene.activeCamera.leftCamera) {
            this.scene.activeCamera.attachControl(this._attachedElement, true);
        }
    }


    _startDrag(pointerId, fromRay = null, startPickedPoint = null) {
        if (!this.scene.activeCamera || this.dragging || !this.attachedNode) {
            return;
        }

        this.prevPointerY = this.scene.pointerY;
        this.dragging = true;
        this.currentDraggingPointerID = pointerId;
        this.onRotateStartObservable.notifyObservers();

        // Detatch camera controls
        if (this.detachCameraControls && this.scene.activeCamera && !this.scene.activeCamera.leftCamera) {
            if (this.scene.activeCamera.inputs.attachedElement) {
                this._attachedElement = this.scene.activeCamera.inputs.attachedElement;
                this.scene.activeCamera.detachControl(this.scene.activeCamera.inputs.attachedElement);
            } else {
                this._attachedElement = null;
            }
        }
    }

    detach() {
        if (this._pointerObserver) {
            this.scene.onPointerObservable.remove(this._pointerObserver);
        }

        this.releaseDrag();
    }
}